// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import type {
  Document,
  DocumentFileSummary,
} from '@shared/data-access/types/engine-types';

export const filterLinkedDocuments = (
  linkedDocuments: readonly Document[] | null | undefined,
  searchQuery: string,
): Document[] => {
  const normalizedQuery = searchQuery.trim().toLowerCase();
  const list = Array.isArray(linkedDocuments) ? linkedDocuments : [];

  if (!normalizedQuery) {
    return list.filter((document): document is Document => Boolean(document));
  }

  const result: Document[] = [];

  for (let index = 0; index < list.length; index += 1) {
    const document = list[index];

    if (!document) {
      continue;
    }

    const title = document.title?.toLowerCase() ?? '';
    const category = document.category?.toLowerCase() ?? '';
    const subcategory = document.subcategory?.toLowerCase() ?? '';
    const files: readonly DocumentFileSummary[] = document.files ?? [];

    let matchesFileName = false;

    for (let fileIndex = 0; fileIndex < files.length; fileIndex += 1) {
      const fileName = files[fileIndex]?.file_name?.toLowerCase() ?? '';

      if (fileName.includes(normalizedQuery)) {
        matchesFileName = true;
        break;
      }
    }

    if (
      title.includes(normalizedQuery) ||
      category.includes(normalizedQuery) ||
      subcategory.includes(normalizedQuery) ||
      matchesFileName
    ) {
      result.push(document);
    }
  }

  return result;
};
